import { render, staticRenderFns } from "./PreparationAttachments.vue?vue&type=template&id=1a8cc63d&"
import script from "./PreparationAttachments.vue?vue&type=script&lang=js&"
export * from "./PreparationAttachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports